import React from 'react'
import { Route } from 'react-router'
import LoginToken from './components/login-token'

const adminRoutes = (
  <>
    <Route path='admin/login/:token' Component={LoginToken} />
  </>
)

export default adminRoutes
